// Custom price per item/total paired display
(function() {
    const getPricePerItem = async () => {
        const api = await window.CPB.createFrontApi('')
        const { Product } = api.State

        let qtyCategory
        Product.panels.forEach(panel => {
            panel.categories.forEach(category => {
                if (category.extraClassName.includes("qty")) {
                    qtyCategory = category
                }
            })
        });
        if (!qtyCategory) return null

        const qtyLayer = Product.layers.find(layer => layer.category === qtyCategory.id)
        const qtyOption = qtyCategory.options.find(option => option.id === qtyLayer.value)

        if (!qtyOption) return null

        const qty = Number(qtyOption.option.data.value)
        const price = Product.price / qty

        const formatted = String((Math.floor(price * 100) / 100).toFixed(2));
        return formatted
    }

    const addCustomPrice = async () => {
        const productTitle = document.querySelector('.cpb-product-title');
        const pricePerItem = document.createElement('div');
        const customPrice = document.createElement('div')
        customPrice.classList.add('cpb-custom-price', 'cpb-product-price')
        pricePerItem.classList.add('cpb-custom-price-perItem', 'cpb-product-price');

        const cpbPrice = document.querySelector('[data-testid="multycurrency-price"]');
        const cpbPriceWrapper = document.querySelector('.cpb-product-actions-first');

        if (!cpbPriceWrapper.querySelector('.cpb-custom-price-perItem'), !cpbPriceWrapper.querySelector('.cpb-custom-price')) {
            cpbPriceWrapper.insertBefore(pricePerItem, cpbPriceWrapper.firstChild);
            cpbPriceWrapper.insertBefore(customPrice, cpbPriceWrapper.firstChild);
        }

        const setCustomPrice = async () => {
            const price = await getPricePerItem();
            // Inject price per item based on instant calculation
            pricePerItem.textContent = `$${price}/ea`;
            // Assign calculated total price display
            customPrice.textContent = cpbPrice.textContent;  
        };


        await setCustomPrice();

        if (cpbPrice && pricePerItem) {
            const observer = new MutationObserver(async () => {
            await setCustomPrice();
            });

            observer.observe(cpbPrice, {
            childList: true,
            characterData: true,
            subtree: true
            });
        } else {
            console.warn('Element not found');
        }
    };


    function customAddToCart() {
        if (!!window._cpb.settings === false) window._cpb.settings = {}

        window._cpb.settings.addToCartOverride = async data => {
            const pricePerItem = document.querySelector(".cpb-custom-price")

            if (!pricePerItem) return
            const addToCartPrice = `$${pricePerItem.textContent?.match(/[\d,]+/)[0]}`
            data.items[0].properties["Price per item"] = addToCartPrice

            fetch("/cart/add.js", {
                "headers": {
                    "content-type": "application/json;charset=UTF-8"
                },
                "body": JSON.stringify({
                    items: data.items
                }),
                "method": "POST"
            }).then(() => {
                if(data.redirect) location.href = '/cart'
            })
        }
    }

    function changeBtnStyles() {
        const form = document.querySelector('.product-form__buttons');
        const customizeBtn = form.querySelector('.button--secondary');
        customizeBtn.classList.remove('button--secondary', 'btn--secondary');
        customizeBtn.classList.add('btn--primary', 'button--primary')
        customizeBtn.id = 'fade'
    }

    document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
        changeBtnStyles()
        addCustomPrice()
        customAddToCart()
    })
})()